import { render, staticRenderFns } from "./tag-nav.vue?vue&type=template&id=4e07e914&scoped=true&"
import script from "./tag-nav.vue?vue&type=script&lang=js&"
export * from "./tag-nav.vue?vue&type=script&lang=js&"
import style0 from "./tag-nav.vue?vue&type=style&index=0&id=4e07e914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07e914",
  null
  
)

export default component.exports